export const verify_PIVA_ADE = `
mutation validatePIVAFromADE($partitaIva: String!) {
    validatePIVAFromADE(partitaIva: $partitaIva) {
        partitaIva
        valida
        stato
        denominazione
        dataInizioAttivita
        status
        title
    }
}`;
export const verify_CF_ADE = `
mutation validateCFFromADE($codiceFiscale: String!) {
    validateCFFromADE(codiceFiscale: $codiceFiscale) {
        codiceFiscale
        valido
        messaggio
    }
}`;